import React from 'react';

import { ItemListPage } from 'pages/items/ItemListPage';

import { routes } from 'utils/routes';

export const SalesItemListPage = () => <ItemListPage detailsPageLinkFn={routes.sales.itemDetails} />;
